import { render, staticRenderFns } from "./clientFullInfo.vue?vue&type=template&id=bfce7bf2&scoped=true&"
import script from "./clientFullInfo.vue?vue&type=script&lang=js&"
export * from "./clientFullInfo.vue?vue&type=script&lang=js&"
import style0 from "./clientFullInfo.vue?vue&type=style&index=0&id=bfce7bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce7bf2",
  null
  
)

export default component.exports